export const emails = {
    sales: 'sales@pocketlaw.com',
    support: 'support@pocketlaw.com',
};
